module.exports = __webpack_public_path__ + "static/backpacking-f224867ed4a4a606f8ea7f5ff7f182d8.jpg";